<template>
    <div id="page-cheat-search">
        <div class="vx-card pr-6 pl-5">
            <vs-table 
                :data="cheatCount"
                :max-items="itemsPerPage"
                pagination
                :stripe="true"
                search
            >
                <template slot="header">
                    <date-range-picker 
                        @date-change="onDateFilterChange" 
                        :initDate="{from: dateFilterFrom, to: dateFilterTo}"
                    />
                    <div class="flex-grow">
                        <vs-dropdown vs-trigger-click class="cursor-pointer">
                            <div class="p-3 border border-solid d-theme-border-grey-light rounded-full cursor-pointer flex items-center justify-between font-medium">
                                <span class="mr-2">
                                    {{ itemsPerPage }}
                                </span>
                                <feather-icon
                                    icon="ChevronDownIcon"
                                    svgClasses="h-4 w-4"
                                />
                            </div>
                            <vs-dropdown-menu>
                                <vs-dropdown-item :key="ipp" v-for="ipp in [50,100,200]" @click="itemsPerPage = ipp"><span>{{ipp}}</span></vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>
                </template>
                <template slot="thead">
                    <vs-th
                        :key="h.id" 
                        v-for="h in header"
                        :sort-key="h.field"
                    >
                        {{ h.title }}
                    </vs-th>
                </template>
                <template slot-scope="{ data }">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :key="h.id" v-for="h in header" :data="data[indextr][h.field]">
                            <template v-if="h.field != 'member_name' && h.field != 'win' && h.field != 'win_count' && data[indextr][h.field] ">
                                <vs-button 
                                    class="vs-button--link"
                                    color="dark" 
                                    type="flat"
                                    target
                                    :href="{ url: '/cheats/detail?member_name='+data[indextr].member_name+'&cheat_id='+[h.field].toString().substring(2)+'&from='+dateFilterFrom+'&to='+dateFilterTo
                                        }"
                                >
                                    {{ data[indextr][h.field] }}
                                </vs-button>
                            </template>
                            <template v-else-if="h.field == 'member_name' && data[indextr].member_name.slice(-1) === '%'">
                                <a target="_blank" :href="'/cheats/detail?member_name='+data[indextr].member_name.slice(0, -1) +'&cheat_id=0&from='+dateFilterFrom+'&to='+dateFilterTo+'&like=true'">
                                    {{ data[indextr][h.field].slice(0, -1) }}
                                </a>
                            </template>
                            <template v-else-if="h.field == 'member_name'">
                                <a target="_blank" :href="'/cheats/detail?member_name='+data[indextr].member_name+'&cheat_id=0&from='+dateFilterFrom+'&to='+dateFilterTo">
                                    {{ data[indextr][h.field] }}
                                </a>
                            </template>
                            <template v-else-if="h.field == 'win'">
                                <span :class="data[indextr][h.field] > 0 ? 'win' : 'loss'">
                                    {{ data[indextr][h.field] }}
                                </span>    
                            </template>
                            <template v-else-if="h.field == 'win_count'">
                                <span :class="data[indextr][h.field] > 0 ? 'win' : 'loss'">
                                    {{ data[indextr][h.field].toFixed(2) }}
                                </span>    
                            </template>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';
import vSelect from 'vue-select';
import moment from "moment";
import DateRangePicker from '@/components/DateRangePicker';

export default {
    // props: ['account_name', 'from', 'to'],
    data(){
        return {
            itemsPerPage: 200,
            currentPage: 1,
            header: [ 
                { title:"Tên thành viên", field:"member_name" }, 
                { title:"Thắng Thua 1", field:"win" },
                { title:"Thắng Thua 2", field:"win_count" },
                { title:"Trùng giây", field:"c_0" }, 
                { title:"Copy", field:"c_1" }, 
                { title:"Cỏ tay", field:"c_2" }, 
                { title:"Cỏ ip", field:"c_3" },
                { title:"Cỏ máy", field:"c_4" }
            ],
            search: '',
            dateFilterFrom: null,
            dateFilterTo: null,
            cheatCount: []
        }
    },
    beforeRouteUpdate (to, from, next) {
        this.search = to.query.search;
        this.dateFilterFrom = to.query.from;
        this.dateFilterTo = to.query.to;

        this.fetchCheatCount();
        next();
    },
    methods:{
        fetchCheatCount() {
            let vm = this;
            
            this.$http.get("cheats/search?search="+this.search+"&from="+this.dateFilterFrom+"&to="+this.dateFilterTo).then((res) => {
                vm.cheatCount = res.data.data;
            });
        },
        onDateFilterChange(data){
            console.log("Go=========================");
            this.dateFilterFrom = data.fromDate;
            this.dateFilterTo = data.toDate;

            console.log(this.dateFilterFrom);
            console.log(this.dateFilterTo);

            this.$router.push({ path: "/cheats/search?search="+this.search+"&from="+this.dateFilterFrom+"&to="+this.dateFilterTo});
        }
    },
    components: {
        DateRangePicker
    },
    created(){
        this.search = this.$route.query.search;
        this.dateFilterFrom = this.$route.query.from;
        this.dateFilterTo = this.$route.query.to;
        this.fetchCheatCount();
    }
};
</script>

<style lang="scss">
.swal2-container{
    z-index: 99999;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td{
    padding: 1px 4px !important;
}
#page-cheat-search .loss{
    color: red;
}
#page-cheat-search .win{
    color: #03f;
}
</style>
